//PVQ Dropdown values
export const systemITLocationOptions = [
  'Home address',
  'Work address',
  'Other',
];

//PVQ Dropdown values
export const systemITTypes = [
  'Classified Information',
  'Personally Identifiable Information',
  'Proprietary Information',
  'Other',
];

//PVQ Dropdown values
export const handingProtectedInformationFrequencyOptions = [
  '1', 
  '2', 
  '3-5', 
  '6-10',
  'Other',
];

//PVQ Dropdown values
export const handlingProtectedInformationDisciplinaryOptions = [
  'Workplace disciplinary or administrative actions.',
  'Civil actions',
  'Criminal actions',
  'Other',
  'No actions taken',
  'Security Violation or Infraction',
];
